import type { QueryKey } from '@tanstack/react-query';

import useQuery from '../../../ReactQuery/useQuery';
import { get } from '../../../redux/api';
import type { ProjectsResponse } from '../../../../shared/projectsV2/response';

function fetchProjectsByLocators(locators: string[]) {
  //  Locators contain `+` and `/`; unencoded, the server reads `+` as a space.
  return get<ProjectsResponse>(
    '/api/v2/projects',
    false,
    { locators, count: locators.length },
    { encodeQuery: true },
  );
}

export const getProjectsByLocatorsQueryKey = (locators: string[]): QueryKey => ['projects', 'by-locators', locators];

/**
 * Looks up projects by locator, for labeling a selection restored from the URL.
 */
export function useProjectsByLocators(locators: string[]) {
  return useQuery<ProjectsResponse>({
    queryKey: getProjectsByLocatorsQueryKey(locators),
    queryFn: () => fetchProjectsByLocators(locators),
    enabled: locators.length > 0,
    staleTime: 1000 * 60,
  });
}
